import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

function closeModalOnEscape (e, elementsToClose) {
  if (e.keyCode === 27) {
    elementsToClose.forEach((element) => {
      if (element.checked) {
        const thisModalRadioClose = element.parentNode.querySelector('[data-close-modal-input]')
        if (!thisModalRadioClose) return
        thisModalRadioClose.checked = true
        clearAllBodyScrollLocks()
      }
    })
  }
}

function handleCloseModalOnEscape () {
  const elementsToCloseOnEscape = document.querySelectorAll('[data-close-on-esc="true"]')

  if (elementsToCloseOnEscape.length) {
    document.addEventListener('keyup', (e) => {
      closeModalOnEscape(e, elementsToCloseOnEscape)
    })
  }
}

function updateBodyScroll (e) {
  if (e.target && e.target.hasAttribute('data-modal-input')) {
    // select element which needs to be kept scrollable
    const thisModalBody = document.querySelector(`#${e.target.getAttribute('name')} [data-modal-content-body]`)

    if (e.target.hasAttribute('data-modal-body-no-scroll') && e.target.checked) {
      if (thisModalBody) {
        disableBodyScroll(thisModalBody)
      }
    }

    if (e.target.hasAttribute('data-close-modal-input') && e.target.checked) {
      clearAllBodyScrollLocks()
    }
  }
}

function resetModalScroll (e) {
  if (e.target && e.target.hasAttribute('data-modal-reset-scroll')) {
    const thisModalBody = document.querySelector(`#${e.target.getAttribute('name')} [data-modal-content-body]`)
    if (thisModalBody) {
      thisModalBody.scrollTop = 0
    }
  }
}

function closeAllModals (e) {
  if (e.target && e.target.hasAttribute('data-modal-close-all')) {
    document.querySelectorAll('[data-close-modal-input]').forEach((element) => {
      if (element.getAttribute('name') !== e.target.getAttribute('name')) {
        element.checked = true
      }
    })
  }
}

// selector of a wrapping element containing both radio inputs and modal
export function openModal (selector) {
  const modal = document.querySelector(selector)
  if (!modal) return

  const modalInput = modal.querySelector('[data-open-modal-input]')
  if (modalInput) {
    modalInput.checked = true
  }

  const modalBody = modal.querySelector('[data-modal-content-body]')
  if (modalInput.hasAttribute('data-modal-body-no-scroll') && modalInput.checked) {
    if (modalBody) {
      disableBodyScroll(modalBody, { reserveScrollBarGap: true })
    }
  }
}

export function closeModal (selector) {
  const modal = document.querySelector(selector)
  if (!modal) return
  const modalInput = modal.querySelector('[data-close-modal-input]')
  if (modalInput) {
    modalInput.checked = true
  }
  clearAllBodyScrollLocks()
}

function openModalOnLoad () {
  openModal('[data-open-on-load]')
}

function handleChangeEvent (e) {
  updateBodyScroll(e)
  resetModalScroll(e)
  closeAllModals(e)
}

export function initModal () {
  handleCloseModalOnEscape()
  openModalOnLoad()

  document.addEventListener('change', handleChangeEvent)
}
